import { OptionResult } from "../types";

export function sortBarChartOptions(options: OptionResult[]): OptionResult[] {
	return [...options].sort((a, b) => {
		if (b.response_count !== a.response_count) {
			return b.response_count - a.response_count;
		}
		return a.option_text.localeCompare(b.option_text);
	});
}

export function calculatePercentage(count: number, total: number): number {
	if (total === 0) return 0;
	return Math.round((count / total) * 100);
}
